export const PROMOTION_BTN_TYPE = {
  LINK: 'link',
  BASKET: 'basket'
};

export const IS_FIRST_ORDER_DISCOUNT_ENABLED = true;
